import React, { useEffect, useState } from "react";

export default function SiteAlert() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem("cookieChoice");
    if (!choice) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookieChoice", "accepted");
    setVisible(false);
  };
  const reject = () => {
    localStorage.setItem("cookieChoice", "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="site-alert" role="dialog" aria-live="polite" aria-label="Informations cookies">
      <div className="site-alert__content">
        <strong>VERATRAC SAFETY</strong> utilise des cookies pour améliorer l’expérience,
        analyser l’usage et sécuriser le site. Vous pouvez accepter ou refuser.
      </div>
      <div className="site-alert__actions">
        <button className="btn btn-primary" onClick={accept}>Accepter</button>
        <button className="btn btn-ghost" onClick={reject}>Refuser</button>
      </div>
    </div>
  );
}
